import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'

import { FormErrorComponent } from './form-error.component'

const components = [
  FormErrorComponent,
]

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    ...components,
  ],
  exports: [
    ...components,
  ],
})
export class FormErrorModule { }
